module.exports = __webpack_public_path__ + "media/Loops Bass.ec7b5704.wav";